module.exports = __webpack_public_path__ + "static/media/logo.3e72f991.png";